import { useCallback, useEffect, useState } from 'react';

import { partnerPortalService } from '../services/partnerPortal.service';
import type { PartnerStatusResponse } from '../types';

export const usePartnerStatus = () => {
  const [status, setStatus] = useState<PartnerStatusResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async () => {
    try {
      setIsFetching(true);
      setError(null);
      const data = await partnerPortalService.getStatus();
      setStatus(data);
    } catch (err: any) {
      setError(err?.message ?? 'failed to load status');
    } finally {
      setIsFetching(false);
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { status, isLoading, isFetching, error, refetch };
};
